var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page"},[_c('NodeGraph'),(_vm.isOpen)?_c('MessageOverlay'):_vm._e(),_c('BottomControls'),_c('SideControls')],1)}
var staticRenderFns = []

export { render, staticRenderFns }